<!--
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-17 09:52:14
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-17 18:20:28
-->
<template>
	<div class="loading-state">
		<div class="wrap" :class="this.$i18n.locale">
      <div class="loading">LOADING...</div>
			<div class="both front">
				<img
					:src="
						require(`../assets/pc-change-images/loading-logo-${this.$i18n.locale}.png`)
					"
					alt="#"
				/>
			</div>
       
		</div>
    
	</div>
</template>

<script>
let timer
export default {
	name: 'LoadingState',
	methods: {
		flip() {}
	},
	mounted() {
		timer = setInterval(() => {
			this.flip()
		}, 4000)
	},
	beforeDestroy() {
		clearInterval(timer)
	}
}
</script>

<style lang="stylus">
.loading-state {
  width: 100vw;
  height: 100vh;
  background: url('../assets/comment/loading-state-bg.png') no-repeat;
  background-size: cover;
  position: relative;

  .wrap {
    position: absolute;
    top 50%
    left 50%
    width 200px
    height 200px
    transform translate(-50%,-50%)
    margin: 0 auto;
    &.en {
      width 300px
      height 300px
    }
    .loading {
      position: absolute;
      left 0;
      right 0;
      bottom -40px;
      color #fff;
      text-align: center;
      font-weight: 500
      font-size: 20px;
      
    }

    .both {
      position: absolute;
      left 0
      top 0
      right 0
      bottom 0
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .front {
      animation scale1 4s infinite alternate
    }
    .back {
      width: 200px;
      height: 200px;
      animation scale2 4s infinite alternate

    }
    @keyframes scale1 {
      0% {
        transform: scale(1)
      }
      25% {
        transform: scale(0)
      }
      50% {
        transform: scale(1);
      }
      75% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
    @keyframes scale2 {
      0% {
        transform: scale(0)
      }
      25% {
        transform: scale(1)
      }
      50% {
        transform: scale(1);
      }
      75% {
        transform: scale(0);
      }
      100% {
        transform: scale(0);
      }
    }
  }
}
/* 手机 */
@media screen and (max-width: 600px) {
 .loading-state {
  background: url('../assets/mobileImagesBg/m-loading-bg.png') no-repeat;
  background-size: cover;
  }
}
</style>
